import { t } from "@/i18n-js/instance";
import { BlockListItem } from "../BlockListItem";

export const LegacyLockscreenItem = () => (
  <BlockListItem
    icon="16-document-text"
    label={t("courses.lockscreen.legacy_lock_screen")}
  />
);
